<script setup lang="ts">
const navItemList = [
  {
    title: 'API Proxies and Secrets',
    name: 'docs-api-proxies-and-secrets',
  },
  {
    title: 'Project Versions',
    name: 'docs-versions',
  },
  {
    title: 'Private Projects',
    name: 'docs-private-projects',
  },
  {
    title: 'Creating a Progressive Web App',
    name: 'docs-pwa',
  },
  {
    title: 'Project Readme',
    name: 'projects-readme',
  },
  // {
  //   title: 'Integrate with GitHub',
  //   name: 'docs-github-integration',
  // },
];
</script>

<template>
  <nav>
    <ul>
      <li v-for="{ title, name } in navItemList" :key="name">
        <router-link v-slot="{ isActive }" :to="{ name }" class="block">
          <div
            class="rounded px-2 py-1.5 font-medium"
            :class="[
              isActive
                ? `relative bg-new-gray-50 opacity-100 after:absolute after:-left-2 after:bottom-1 after:top-1 after:w-[3px] after:rounded after:bg-new-green-700 after:content-[''] dark:bg-new-slate-700`
                : 'opacity-75 hover:bg-new-gray-50 hover:font-medium hover:opacity-100 dark:hover:bg-new-slate-700',
            ]"
          >
            {{ title }}
          </div>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<style scoped lang="postcss"></style>
